import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Dashboard from '../Dashboard';
import Login from '../Login';
import Home from '../Home';
import Towers from '../Towers';
import Players from '../Players';
import Invites from '../Invites';
import Mailing from '../Mailing';
import Recipients from '../Recipients';
import Users from '../Users';
import Contract from '../Contract';
import NotFound from '../NotFound';
import PrivateRoute from './PrivateRoute.jsx';

function App(props) {
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/login" component={Login}/>
        <PrivateRoute exact path="/" auth={props.isAuthenticated}>
          <Dashboard title={'Dashboard'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Home/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/towers" auth={props.isAuthenticated}>
          <Dashboard title={'Towers'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Towers/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/players" auth={props.isAuthenticated}>
          <Dashboard title={'Players'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Players/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/contract" auth={props.isAuthenticated}>
          <Dashboard title={'Smart Contract'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Contract/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/invites" auth={props.isAuthenticated}>
          <Dashboard title={'Invites'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Invites/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/mailing" auth={props.isAuthenticated}>
          <Dashboard title={'Mailing'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Mailing/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/recipients" auth={props.isAuthenticated}>
          <Dashboard title={'Recipients'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Recipients/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="/users" auth={props.isAuthenticated}>
          <Dashboard title={'Users'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><Users/></Dashboard>
        </PrivateRoute>
        <PrivateRoute exact path="*" auth={props.isAuthenticated}>
          <Dashboard title={'Error 404'} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}><NotFound/></Dashboard>
        </PrivateRoute>
      </Switch>
    </BrowserRouter>
  );
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  const { isAuthenticated } = state.auth;
  return {
    isAuthenticated,
  };
}

export default connect(mapStateToProps)(App);
